import type { KpiRow, ReviewState } from './types'

export type FocusHighlight = { term: string; page?: number | null; align?: 'exact' | 'offset' } | null

export type ValXmlState = {
    uploadedFile: File | null
    pdfUrl: string | null
    kpiRows: KpiRow[]
    processingError: string | null
    isPreprocessing: boolean
    pageTexts: string[]
    focusHighlight: FocusHighlight
    reviewState: ReviewState
    lastReviewSummary: string | null
}

export type ValXmlAction =
    | { type: 'SET_PROCESSING_ERROR'; payload: string | null }
    | { type: 'START_PREPROCESSING' }
    | { type: 'STOP_PREPROCESSING' }
    | { type: 'SET_UPLOADED_FILE'; payload: File | null }
    | { type: 'SET_PDF_URL'; payload: string | null }
    | { type: 'SET_KPI_ROWS'; payload: KpiRow[] }
    | { type: 'SET_PAGE_TEXTS'; payload: string[] }
    | { type: 'SET_FOCUS_HIGHLIGHT'; payload: FocusHighlight }
    | { type: 'SET_REVIEW_STATE'; payload: ReviewState }
    | { type: 'SET_LAST_REVIEW_SUMMARY'; payload: string | null }
    | { type: 'CLEAR_ALL' }

export const initialState: ValXmlState = {
    uploadedFile: null,
    pdfUrl: null,
    kpiRows: [],
    processingError: null,
    isPreprocessing: false,
    pageTexts: [],
    focusHighlight: null,
    reviewState: { status: 'idle', disagreements: [] },
    lastReviewSummary: null,
}

export const reducer = (state: ValXmlState, action: ValXmlAction): ValXmlState => {
    switch (action.type) {
        case 'SET_PROCESSING_ERROR':
            return { ...state, processingError: action.payload }
        case 'START_PREPROCESSING':
            return { ...state, isPreprocessing: true }
        case 'STOP_PREPROCESSING':
            return { ...state, isPreprocessing: false }
        case 'SET_UPLOADED_FILE':
            return { ...state, uploadedFile: action.payload }
        case 'SET_PDF_URL':
            return { ...state, pdfUrl: action.payload }
        case 'SET_KPI_ROWS':
            return { ...state, kpiRows: action.payload }
        case 'SET_PAGE_TEXTS':
            return { ...state, pageTexts: action.payload }
        case 'SET_FOCUS_HIGHLIGHT':
            return { ...state, focusHighlight: action.payload }
        case 'SET_REVIEW_STATE':
            return { ...state, reviewState: action.payload }
        case 'SET_LAST_REVIEW_SUMMARY':
            return { ...state, lastReviewSummary: action.payload }
        case 'CLEAR_ALL':
            return {
                ...state,
                uploadedFile: null,
                pdfUrl: null,
                kpiRows: [],
                processingError: null,
                isPreprocessing: false,
                pageTexts: [],
                focusHighlight: null,
                reviewState: { status: 'idle', disagreements: [] },
                lastReviewSummary: null,
            }
        default:
            return state
    }
}
